"use client";

import { useEffect, useState } from "react";
import { FaCalendarAlt, FaLightbulb, FaMapMarkerAlt } from "react-icons/fa";
import { FixedApplyButton } from "./fixedApplyButton";

interface FixedEventInfoProps {
	googleFormUrl: string;
}

export const FixedEventInfo = ({ googleFormUrl }: FixedEventInfoProps) => {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const handleScroll = (): void => {
			let footer: Element | null = null;

			// "Startup Hub Kosen"テキストを含むp要素を検索し、その親のdivを取得
			const startupText = Array.from(document.querySelectorAll("p")).find((p) =>
				p.textContent?.includes("Startup Hub Kosen"),
			);

			if (startupText) {
				// そのp要素の親で、背景色クラスを持つdivを探す
				footer = startupText.closest(
					'div[class*="bg-sky"], div[class*="bg-suzuka"], div[class*="bg-techfes"], div[class*="bg-wakayama"]',
				);
			}

			// 見つからない場合、"Copyright"テキストで検索
			if (!footer) {
				const copyrightText = Array.from(document.querySelectorAll("p")).find(
					(p) => p.textContent?.includes("Copyright"),
				);

				if (copyrightText) {
					footer = copyrightText.closest(
						'div[class*="bg-sky"], div[class*="bg-suzuka"], div[class*="bg-techfes"], div[class*="bg-wakayama"]',
					);
				}
			}

			if (!footer) {
				console.log("Footer not found");
				// footerが見つからない場合は表示を維持
				setIsVisible(true);
				return;
			}

			const footerRect = footer.getBoundingClientRect();
			const windowHeight = window.innerHeight;

			// footerが画面に入ってきたら非表示
			const shouldHide = footerRect.top <= windowHeight - 120;

			console.log("Footer found:", footer.tagName, footer.className);
			console.log(
				"Footer top:",
				footerRect.top,
				"Window height:",
				windowHeight,
				"Threshold:",
				windowHeight - 120,
				"Should hide:",
				shouldHide,
			);

			setIsVisible(!shouldHide);
		};

		// スクロールイベントとリサイズイベントの両方を監視
		window.addEventListener("scroll", handleScroll, { passive: true });
		window.addEventListener("resize", handleScroll, { passive: true });

		// 少し遅延させて初期状態をチェック（DOM構築完了後）
		setTimeout(handleScroll, 100);

		return () => {
			window.removeEventListener("scroll", handleScroll);
			window.removeEventListener("resize", handleScroll);
		};
	}, []);

	if (!isVisible) return <></>;

	return (
		<div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 w-[calc(100vw-2rem)] max-w-[700px]">
			<div className="bg-white shadow-lg rounded-2xl border border-gray-200 px-6 py-4 w-full">
				<div className="flex items-center justify-between w-full">
					{/* 左側：イベント情報 */}
					<div className="flex flex-col gap-2 flex-1">
						{/* 日付 */}
						<div className="flex items-center gap-2">
							<div className="bg-gray-200 rounded-md p-2 flex items-center justify-center w-8 h-8">
								{FaCalendarAlt({ className: "text-gray-600 text-sm" })}
							</div>
							<span className="text-black font-bold font-zenMaru text-sm">
								2025年12月16日（火）〜2025年12月20日（土）
							</span>
						</div>

						{/* 場所 */}
						<div className="flex items-center gap-2">
							<div className="bg-gray-200 rounded-md p-2 flex items-center justify-center w-8 h-8">
								{FaMapMarkerAlt({ className: "text-gray-600 text-sm" })}
							</div>
							<span className="text-black font-bold font-zenMaru text-sm">
								鈴鹿高専 起業家工房
							</span>
						</div>

						{/* テーマ */}
						<div className="flex items-center gap-2">
							<div className="bg-gray-200 rounded-md p-2 flex items-center justify-center w-8 h-8">
								{FaLightbulb({ className: "text-gray-600 text-sm" })}
							</div>
							<span className="text-black font-bold font-zenMaru text-sm">
								<span className="whitespace-nowrap">テーマ</span>
								<span className="whitespace-nowrap">
									「持続可能な社会を作る」
								</span>
							</span>
						</div>
					</div>

					{/* 右側：応募ボタン */}
					<div className="ml-4">
						<FixedApplyButton googleFormUrl={googleFormUrl} />
					</div>
				</div>
			</div>
		</div>
	);
};
